export default __webpack_public_path__ + "static/media/939.fa2c572e.png";